import {Choice, ChoiceProps} from 'platform/components';
import {Box} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

/** Sized to the longest option so a translated sort label is not clipped (T20-139508). */
const SORT_CHOICE_MIN_WIDTH = 56;

interface SourcingTableSortChoiceProps extends TestIdProps {
  value: string | null;
  options: ChoiceProps<string>['options'];
  onChange: ChoiceProps<string>['onChange'];
  isFullWidth?: boolean;
}

export function SourcingTableSortChoice(props: SourcingTableSortChoiceProps) {
  return (
    <Box
      width={props.isFullWidth ? '100%' : 'fit-content'}
      minWidth={props.isFullWidth ? undefined : SORT_CHOICE_MIN_WIDTH}
    >
      <Choice
        value={props.value}
        onChange={props.onChange}
        options={props.options ?? []}
        isNotClearable
        data-testid={suffixTestId('sortByOptions', props)}
      />
    </Box>
  );
}
